import styled from "styled-components";
import { shimmer } from "../../utils/animations";

const Container = styled.div<{
  $width?: string | number;
  $height?: string | number;
  $variant?: string;
}>`
  width: ${({ $width }) =>
    typeof $width === "number" ? `${$width}px` : $width || "80px"};
  height: ${({ $height }) =>
    typeof $height === "number" ? `${$height}px` : $height || "30px"};
  border-radius: ${({ $variant }) => ($variant === "circle" ? "50%" : "4px")};
  background: var(--color-light-100);
  position: relative;
  
  &::before {
    content: "";
    position: absolute;
    display: block;
    height: ${({ $height }) =>
      typeof $height === "number" ? `${$height}px` : $height || "30px"};
    width: ${({ $width }) =>
      typeof $width === "number" ? `${$width}px` : $width || "80px"};
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.85) 44.71%,
      rgba(255, 255, 255, 0) 100%
    );

    animation: ${shimmer} 1s ease-in-out infinite;
  }
`;

type TSkeletonVariants = "radio" | "box" | "circle" | "square";

export type TSkeletonProps = {
  variant?: TSkeletonVariants;
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
};

const Skeleton: React.FC<TSkeletonProps> = ({
  variant = "box",
  width,
  height,
  style,
}) => {
  return (
    <Container
      $variant={variant}
      $width={width}
      $height={height}
      style={style}
    />
  );
};

export default Skeleton;
